export class User {
    id:string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    address: string;
    postalCode: string;
    location: string;
    autoLoggedIn : boolean;
    isMemberExpired: boolean;
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/user.ts